<template>
	<div>

		<Form ref="form" :model="dictDataTpye" :label-width="150" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="6">
				<FormItem label="分组标识：" prop="dictCode" label-for="dictCode">
					<Input v-model="dictDataTpye.dictCode" placeholder="请输入" element-id="dictCode" />
				</FormItem>
				</Col>

				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>

			</Row>
		</Form>
		<Button type="success" ghost size="large" @click="dictAddMain()">新增字典</Button>
		<Button type="info" ghost size="large" @click="updateDictCacheMain()">更新缓存</Button>
		<Table stripe :columns="columns1" :data="data1">
			<template slot="action" slot-scope="{ row, index }">
				<Button type="info" ghost size="small" style="margin-right: 5px" @click="dictEditMain(row)">编辑</Button>
				<Button type="error" ghost size="small" @click="dictDelMain(row)">删除</Button>
			</template>
		</Table>
		<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage" show-total
			show-elevator next-text="下一页" />

		<div>
			<Modal v-model="modal1" title="字典表新增" width="20%" @on-ok="dictAddfunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="分组标识：" prop="dictCode">
						<Input v-model="modalformValidata.dictCode" />
					</FormItem>
					<FormItem label="值：" prop="dictValue">
						<Input v-model="modalformValidata.dictValue" />
					</FormItem>
					<FormItem label="名称：" prop="dictName">
						<Input v-model="modalformValidata.dictName" />
					</FormItem>
					<FormItem label="顺序：" prop="dictOrdinal">
						<Input v-model="modalformValidata.dictOrdinal"
							@on-keyup="intCheck(modalformValidata.dictOrdinal)" />
					</FormItem>
				</Form>
			</Modal>
		</div>
		<div>
			<Modal v-model="modal2" title="字典表编辑" width="20%" @on-ok="dictEditfunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="分组标识：" prop="dictCode">
						<Input v-model="modalformValidata.dictCode" />
					</FormItem>
					<FormItem label="值：" prop="dictValue">
						<Input v-model="modalformValidata.dictValue" />
					</FormItem>
					<FormItem label="名称：" prop="dictName">
						<Input v-model="modalformValidata.dictName" />
					</FormItem>
					<FormItem label="顺序：" prop="dictOrdinal">
						<Input v-model="modalformValidata.dictOrdinal"
							@on-keyup="intCheck(modalformValidata.dictOrdinal)" />
					</FormItem>
				</Form>
			</Modal>
		</div>
	</div>


</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		isHistory: 'N',
		dictCode: null,
	};
	import {
		getDictList,
		getDictSingle,
		dictAdd,
		dictEdit,
		dictDel,
		updateDictCache
	} from '@/network/index.js';
	export default {
		data() {
			return {
				columns1: [{
						title: '分组标识',
						key: 'dictCode'
					},
					{
						title: '值',
						key: 'dictValue'
					},
					{
						title: '名称',
						key: 'dictName'
					},
					{
						title: '顺序',
						key: 'dictOrdinal'
					},

					{
						title: '创建时间',
						key: 'createTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 140,
						align: 'center',
						fixed: 'right',
					}
				],
				ruleValidate: {
					dictCode: [{
						required: true,
						message: '分组标识必须填写',
						trigger: 'blur'
					}],
					dictValue: [{
						required: true,
						message: '值必须填写',
						trigger: 'blur'
					}],
					dictName: [{
						required: true,
						message: '名称必须填写',
						trigger: 'blur'
					}],
					dictOrdinal: [{
						required: true,
						message: '顺序必须填写',
						trigger: 'blur'
					}],
				},
				modalformValidata: {
					dictId: '',
					dictCode: '',
					dictValue: '',
					dictName: '',
					dictOrdinal: '',
				},
				data1: [],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,

				dictId: 0,
				modal1: false,
				modal2: false,


				dictDataTpye: {
					dictCode: '',
				},
				pointChangerType: [],



			}
		},
		created() {
			this.initData(paramter);


		},
		methods: {
			//更新缓存
			updateDictCacheMain() {
				updateDictCache(null).then(res => {
						if (res.success == true) {
							this.$Message.success('缓存更新成功!');


						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},

			//删除方法
			dictDelMain(row) {
				dictDel(row.dictId, null).then(res => {
						if (res.success == true) {
							this.$Message.success('用户删除成功!');

							this.initData(paramter);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						console.log(error)
					});
			},

			//修改主方法
			dictEditMain(row) {
				this.modal2 = true;
				this.modalformValidata.dictCode = row.dictCode;
				this.modalformValidata.dictValue = row.dictValue;
				this.modalformValidata.dictName = row.dictName;
				this.modalformValidata.dictOrdinal = row.dictOrdinal;
				this.dictId = row.dictId;
				 
			},
			//修改方法
			dictEditfunc() {
				let paramter = {
					dictCode: this.modalformValidata.dictCode,
					dictValue: this.modalformValidata.dictValue,
					dictName: this.modalformValidata.dictName,
					dictOrdinal: this.modalformValidata.dictOrdinal,
					isHistory: 'N ',
				};

				dictEdit(this.dictId, paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('码表修改成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								dictCode: this.modalformValidata.dictCode,
							};
							this.initData(paramtertemp);

						} else {
							this.modal2 = false;
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('码表修改失败，请联系管理员!');
						//添加失败关闭对话框
						this.modal2 = false;

					});

			},

			//新增主方法
			dictAddMain(row) {
				this.modal1 = true;
			},
			//新增方法
			dictAddfunc() {
				let paramter = {
					dictCode: this.modalformValidata.dictCode,
					dictValue: this.modalformValidata.dictValue,
					dictName: this.modalformValidata.dictName,
					dictOrdinal: this.modalformValidata.dictOrdinal,
					isHistory: 'N ',
				};

				dictAdd(paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('码表添加成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								dictCode: this.modalformValidata.dictCode,
							};
							this.initData(paramtertemp);

						} else {
							// 官方目前没有解决方案
							this.modal1 = false;
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('码表添加失败，请联系管理员!');
						//添加失败关闭对话框
						this.modal1 = false;

					});

			},


			//检查输入的是否是正整数
			intCheck() {
				this.modalformValidata.dictOrdinal = this.modalformValidata.dictOrdinal.replace(/\D/g, '')
			},

			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},
			initData(paramter) {


				getDictList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							// debugger;
							// console.log(res.data.obj.dataList[i].dictId);
							this.data1.push({
								dictId: res.data.obj.dataList[i].dictId,
								dictCode: res.data.obj.dataList[i].dictCode,
								dictValue: res.data.obj.dataList[i].dictValue,
								dictName: res.data.obj.dataList[i].dictName,
								dictOrdinal: res.data.obj.dataList[i].dictOrdinal,
								createTime: res.data.obj.dataList[i].createTime,
							});
						}
						
						 
					})
					.catch(error => {});


			},





			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
				paramter.dictCode = null;
			},
			//查询提交
			handleSubmit() {

				if (this.dictDataTpye.dictCode != null && this.dictDataTpye.dictCode != '') {
					paramter.dictCode = this.dictDataTpye.dictCode;
				}

				getDictList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								dictId: res.data.obj.dataList[i].dictId,
								dictCode: res.data.obj.dataList[i].dictCode,
								dictValue: res.data.obj.dataList[i].dictValue,
								dictName: res.data.obj.dataList[i].dictName,
								dictOrdinal: res.data.obj.dataList[i].dictOrdinal,
								createTime: res.data.obj.dataList[i].createTime,
							});
						}
					})
					.catch(error => {});
			},
		},


	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}


	#divcss5 {
		display: flex; //水平分布
		border: 1px dashed #ff0000;
		height: 30px;
		width: 100%;


	}

	.item {
		flex: 1; //等分
		text-align: center; //等分后居中
		font-size: 18px;
	}


	#head-logo {
		width: 200px;
		height: 200px;
		text-align: center;
		border-radius: 3px; //添加圆角
	}
</style>
